import './OxylinkAppTheme.scss';

import { DefaultIdeLinkTheme, IdeLinkTheme } from '../../../xlink/configs/IdeLinkTheme';
import auditsNavbar from '../assets/audits/ic_audits.svg';
import challengesListDefaultIcon from '../assets/challenges/default_img_challenges.svg';
import challengesNavbar from '../assets/challenges/ic_challenges.svg';
import collectionsListDefaultIcon from '../assets/collections/default_img_collections.svg';
import collectionsProductDefaultImage from '../assets/collections/default_img_product.svg';
import collectionsNavbar from '../assets/collections/ic_collections.svg';
import contactsNavbar from '../assets/contacts/ic-contacts.svg';
import eventListDefaultIcon from '../assets/events/default-img-events.svg';
import eventsNavbar from '../assets/events/ic-events.svg';
import adminsNavbar from '../assets/navbar/ic-admins.svg';
import areasNavbar from '../assets/navbar/ic-areas.svg';
import rolesNavbar from '../assets/navbar/ic-roles.svg';
import sectorsNavbar from '../assets/navbar/ic-sectors.svg';
import shopsNavbar from '../assets/navbar/ic-shops.svg';
import statsNavbar from '../assets/navbar/ic-stats.svg';
import tagsNavbar from '../assets/navbar/ic-tags.svg';
import teamsNavbar from '../assets/navbar/ic-teams.svg';
import usersNavbar from '../assets/navbar/ic-users.svg';
import newsListDefaultIcon from '../assets/news/default-img-news.svg';
import newsNavbar from '../assets/news/ic-news.svg';
import packagedOrdersProductDefaultIcon from '../assets/offers/default-img-product-square.svg';
import packagedOrdersListDefaultIcon from '../assets/offers/default_img_packaged_orders.svg';
import offersNavbar from '../assets/offers/ic_offers.svg';
import quizzesNavbar from '../assets/quizzes/ic_quizzes.svg';
import surveysListDefaultIcon from '../assets/surveys/default-img-surveys.svg';
import surveysNavbar from '../assets/surveys/ic-surveys.svg';
import videosListDefaultIcon from '../assets/videos/default-img-videos.svg';
import videosNavbar from '../assets/videos/ic-videos.svg';

//! SAME AS DEMOLINK
export const OxylinkAppTheme: IdeLinkTheme = {
	...DefaultIdeLinkTheme,

	//*ADMIN MODULES
	admins: { ...DefaultIdeLinkTheme.admins, navbarIcon: adminsNavbar },
	teams: { ...DefaultIdeLinkTheme.teams, navbarIcon: teamsNavbar },
	areas: { ...DefaultIdeLinkTheme.areas, navbarIcon: areasNavbar },
	sectors: { ...DefaultIdeLinkTheme.sectors, navbarIcon: sectorsNavbar },
	shops: { ...DefaultIdeLinkTheme.shops, navbarIcon: shopsNavbar },
	users: { ...DefaultIdeLinkTheme.users, navbarIcon: usersNavbar },
	stats: { ...DefaultIdeLinkTheme.stats, navbarIcon: statsNavbar },
	roles: { ...DefaultIdeLinkTheme.roles, navbarIcon: rolesNavbar },
	tags: { ...DefaultIdeLinkTheme.tags, navbarIcon: tagsNavbar },

	//*MODULES
	offers: {
		...DefaultIdeLinkTheme.offers,
		className: 'oxylink-theme oxylink-offers',
		backgroundColor: '#6bc0e1',
		navbarIcon: offersNavbar,
		listDefaultIcon: packagedOrdersListDefaultIcon,
		productDefaultIcon: packagedOrdersProductDefaultIcon,
	},
	news: {
		...DefaultIdeLinkTheme.news,
		className: 'oxylink-theme oxylink-news',
		backgroundColor: '#1a936f',
		navbarIcon: newsNavbar,
		listDefaultIcon: newsListDefaultIcon,
	},
	events: {
		...DefaultIdeLinkTheme.events,
		className: 'oxylink-theme oxylink-events',
		backgroundColor: '#0ec4b0',
		navbarIcon: eventsNavbar,
		listDefaultIcon: eventListDefaultIcon,
	},
	surveys: {
		...DefaultIdeLinkTheme.surveys,
		className: 'oxylink-theme oxylink-surveys',
		backgroundColor: '#4a84cc',
		navbarIcon: surveysNavbar,
		listDefaultIcon: surveysListDefaultIcon,
	},
	videos: {
		...DefaultIdeLinkTheme.videos,
		className: 'oxylink-theme oxylink-videos',
		backgroundColor: '#c20700',
		navbarIcon: videosNavbar,
		listDefaultIcon: videosListDefaultIcon,
	},
	collections: {
		...DefaultIdeLinkTheme.collections,
		className: 'oxylink-theme oxylink-collections',
		backgroundColor: '#da3583',
		navbarIcon: collectionsNavbar,
		listDefaultIcon: collectionsListDefaultIcon,
		productDefaultIcon: collectionsProductDefaultImage,
	},
	quizzes: { ...DefaultIdeLinkTheme.quizzes, navbarIcon: quizzesNavbar },
	challenges: {
		...DefaultIdeLinkTheme.challenges,
		className: 'oxylink-theme oxylink-challenges',
		backgroundColor: '#c8a000', //ocre
		navbarIcon: challengesNavbar,
		listDefaultIcon: challengesListDefaultIcon,
	},
	audits: {
		...DefaultIdeLinkTheme.audits,
		className: 'oxylink-theme oxylink-audits',
		backgroundColor: '#febf01', //marigold
		navbarIcon: auditsNavbar,
	},
	contacts: {
		...DefaultIdeLinkTheme.contacts,
		className: 'oxylink-theme oxylink-contacts',
		backgroundColor: '#106051',
		navbarIcon: contactsNavbar,
	},
};
